import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SearchService } from '../../services/Search/search.service';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, UrlSegment } from '@angular/router';
import { gsap, Expo, Quad } from 'gsap';
import moment from 'moment-timezone';
import { FooterTrustarcComponent } from "../footer-trustarc/footer-trustarc.component";
import { Subscription } from 'rxjs';

export class Link {
    title: string
    url: string
    search: string

    constructor(title: string, url: string, search: string = '') {
        this.title = title
        this.url = url
        this.search = search
    }
}

@Component({
    selector: 'app-footer',
    imports: [
        CommonModule,
        RouterModule,
        FooterTrustarcComponent
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    public movieLinks: Link[] = []
    public siteLinks: Link[] = []
    public legalLinks: Link[] = []
    public year: string
    public hidden: boolean = true

    currentUrlObservable: string = '';
    

    constructor(
        public searchService: SearchService,
        private router: Router,
    ) {
        this.siteLinks = [
            new Link('Home', '/'),
            new Link('Advanced Search', '/search'),
            new Link('Profile', '/profile/wishlist'),
            new Link('Contact', '/contact')
        ]

        this.movieLinks = [
            new Link('Twilight', '/movies/1930018'),
            new Link('Breaking Dawn, Part 2', '/movies/2550036'),
            new Link('Dirty Dancing', '/movies/1000333'),
            new Link('New Moon', '/movies/2550034'),
            new Link('Eclipse', '/movies/2550006'),
            new Link('Breaking Dawn, Part 1', '/movies/2550035'),
            new Link('The Hunger Games', '/movies/9382200'),
            new Link('Catching Fire', '/movies/9382463'),
            new Link('Mockingjay Part 2', '/movies/9382465'),
            new Link('Mockingjay Part 1', '/movies/9382464'),
            new Link('But I\'m A Cheerleader', '/movies/8000115',),
            new Link('Ghost in the Shell (1995)', '/movies/3340438'),
            new Link('La La Land', '/movies/2550397'),
            new Link('Battle Royale (2000)', '/movies/3340098'),
            new Link('American Psycho', '/movies/9380020'),
            new Link('Snowpiercer (2013)', '/movies/3370100'),
        ]

        this.legalLinks = [
            new Link('Terms Of Use', 'https://www.lionsgate.com/legal/terms-of-use'),
            new Link('Privacy Notice', 'https://www.lionsgate.com/legal/privacy-policy'),
            new Link('Do Not Sell/Share My Personal Information', 'https://www.lionsgate.com/legal/do-not-sell-my-information'),
            new Link('California Privacy Rights', 'https://www.lionsgate.com/legal/privacy-policy#CaliforniaResidents'),
        ]

        this.year = moment(new Date()).format('YYYY');

        this.router.events.subscribe((e) => {
            if (e instanceof NavigationEnd) {
                if (window.location.href.includes('/login')) {
                    this.hidden = true
                }
                else {
                    this.hidden = false
                }
            }
        });
    }

    onClick(item: Link) {
        this.searchService.searchText = item.search;
        this.searchService.forceSearch$.next(item.search)
        this.router.navigate(['/search']);
    }

    ngOnInit() {
        let currentRoute = this.router.url;
        if (currentRoute.includes('/login')) {
            this.hidden = true
        }
        else {
            this.hidden = false
        }


        gsap.set('.footer', { autoAlpha: 0 })
        setTimeout(() => {
            gsap.fromTo('.footer', 0.5, { autoAlpha: 0 }, { autoAlpha: 1, delay: '1s' });
        }, 3000);
        // setTimeout(() => {
        //     gsap.to('.footer', 0.5, { autoAlpha: 1, delay: '1s' });
        // }, 3010);
    }
}
